import { UserEvent } from '../models/user';
import useGetUserData from './useGetUserData';

const useGetUserEventData = (eventId: string, options?: { skip?: boolean }): UserEvent | null => {
  const userData = useGetUserData(options);
  return userData?.user_events?.find((ue) => ue.event_id === eventId) ?? null;
};

export default useGetUserEventData;
